var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTrophy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0c-.9 0-2 1-2 2H6c0-1-1.1-2-2-2H0v9c0 1 1 2 2 2h2.2c.4 2 1.7 3.7 4.8 4v2.08C6 17.54 6 20 6 20h8s0-2.46-3-2.92V15c3.1-.3 4.4-2 4.8-4H18c1 0 2-1 2-2V0h-4zM4 9H2V2h2v7zm10 .5c0 1.93-.58 3.5-4 3.5-3.41 0-4-1.57-4-3.5V4h8v5.5zm4-.5h-2V2h2v7z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2IDBDMTUuMSAwIDE0IDEgMTQgMkg2QzYgMSA0LjkgMCA0IDBIMFY5QzAgMTAgMSAxMSAyIDExSDQuMkM0LjYgMTMgNS45IDE0LjcgOSAxNVYxNy4wOEM2IDE3LjU0IDYgMjAgNiAyMEgxNEMxNCAyMCAxNCAxNy41NCAxMSAxNy4wOFYxNUMxNC4xIDE0LjcgMTUuNCAxMyAxNS44IDExSDE4QzE5IDExIDIwIDEwIDIwIDlWMEgxNlpNNCA5SDJWMkg0VjlaTTE0IDkuNUMxNCAxMS40MyAxMy40MiAxMyAxMCAxM0M2LjU5IDEzIDYgMTEuNDMgNiA5LjVWNEgxNFY5LjVaTTE4IDlIMTZWMkgxOFY5WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { SvgIconTrophy as ReactComponent };